import { render } from "./HomeSectionTitle.vue?vue&type=template&id=4544b30a"
import script from "./HomeSectionTitle.vue?vue&type=script&lang=js"
export * from "./HomeSectionTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__